var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 285.29 315.91",
    width: "220px",
    height: "220px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff7e1",
    cx: 142.64,
    cy: 173.27,
    r: 142.64
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M164.93,280s-14.54,33.34-32.46,33.34S100,280,100,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M185.19,280s-14.53,33.34-32.46,33.34S120.27,280,120.27,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M235.89,280s-14.53,12.55-32.46,12.55S171,280,171,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M210.71,280s-14.53,18.59-32.46,18.59S145.79,280,145.79,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M140.82,280s-14.53,18.59-32.46,18.59S75.9,280,75.9,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M114.32,280s-14.54,12.55-32.46,12.55S49.39,280,49.39,280Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M57.57,170.28c-4,1.35-11.41,31.39-8.73,41.51a2.82,2.82,0,0,0,5.5-1.23c-.2-4.93,2.86-30.43,8.07-34.61S57.57,170.28,57.57,170.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M69.45,223.58c1.11,10.8,4.45,53.31,4.45,57.17,0,1.67,23.61,1,26.11.66s1.15-5.57,1.15-7.32,4.48-45.52,3-56.12C101.44,199.38,66.67,196.54,69.45,223.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M153.72,223.58c1.11,10.8,4.45,53.31,4.45,57.17,0,1.67,23.61,1,26.11.66s1.15-5.57,1.15-7.32,4.48-45.52,2.95-56.12C185.71,199.38,150.94,196.54,153.72,223.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#b6b6dd",
    cx: 124.65,
    cy: 188.91,
    rx: 71.34,
    ry: 62.58
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.93,213.82C184,245,156.84,251.49,124.65,251.49c-17.53,0-33.59-3.3-46-11-15.48-9.62-15.16-29,21.41-14.3C135.69,240.46,149.3,239.92,192.93,213.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M146.21,228.81c1.11,9.83,4.45,48.53,4.45,52,0,1.52,23.6.92,26.11.6s1.14-5.07,1.14-6.67,4.49-41.43,3-51.08C178.19,206.78,143.42,204.19,146.21,228.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M61.94,227.73c1.11,10,4.45,49.52,4.45,53.1,0,1.55,23.6.94,26.11.61s1.14-5.17,1.14-6.8,4.49-42.28,3-52.12C93.92,205.25,59.15,202.61,61.94,227.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.6,202.23c-.51,9.89-4.42,18-6.86,25-9.92,11.34-37.77-18.2-38.69-26-1.77-39.36,10.35-57.28,22.52-46.38C185.13,167,195.53,184,194.6,202.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M145.55,149.56c-10.49-9.68-33.41,23.26-32.65,26.46s43.69,67.11,51.34,65.06S184.86,216.8,184.87,210,159.29,153.42,145.55,149.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M202.33,118.4c-4.3-12.92,25.94-8.36,28.08-5.91s37.52,70.11,34,74-23.27-.85-28.29-5S201.5,130,202.33,118.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M172.16,207.59c10.54,3.56,30.33-8.39,33.3-5.62s3.66,3.34,7,2.18c22.53,10,44.89,25.54,61.41-25.58,1.89-5.85,12.39-5.3,5.22-13.19-2.83-3.11-8.57,1.79-9.54-3.62-2.27-12.56-19.89,41.67-36.29,26.19,3.55-2-1.84-1.7-1.92-4.3-.26-7.84,4.86-2.26,7.4-13.1.68-2.9-15.87-51.64-27.36-53.31-4.89-.72-10.76-8.79-31.93,1.47a180.47,180.47,0,0,0-20.06,11.16c-19.89,12.57-16.13,21.81-18.1,26.34C136.66,166.86,169.33,206.63,172.16,207.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4f4f4f",
    cx: 189.34,
    cy: 160.01,
    rx: 5.51,
    ry: 7.21,
    transform: "translate(-53.9 112.17) rotate(-29.07)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4f4f4f",
    cx: 211.67,
    cy: 149.93,
    rx: 5.51,
    ry: 7.21,
    transform: "translate(-46.19 121.76) rotate(-29.07)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M174.12,148.89c-1.24.72,2.6,1.87,5.62.12l8.7-5c1.1-.63,1.55-4.27-1.15-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M214.87,130.5c1.35-.48-.25,3.19-3.53,4.37l-9.46,3.4c-1.2.43-4.27-1.57-1.34-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M139,88.37c7.12-6,15.39-9.8,20.13-16.42,5-7,8.05,1.91,5.13,6,2.17.1,5.16,2.72,2.32,15.11-2.89,12.61-22.56,23.12-25.39,17.62C135.36,109.81,130.57,95.47,139,88.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M110.28,88.37c-7.13-6-15.39-9.8-20.14-16.42-5-7-8,1.91-5.13,6-2.17.1-5.16,2.72-2.32,15.11,2.89,12.61,22.57,23.12,25.4,17.62C113.94,109.81,118.73,95.47,110.28,88.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1c6",
    d: "M141.46,115.68s-19,8.61-21.51,9.42-6.88,1.92-6.49.64c-5.59,4.87-5.81,1.05-5.84.86-.8,1.36-4.82,2-4.38-.86-.48.75-4.56,1.72-4-1.38.15-.88,3-16.31,3-16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.46,115.68s-19,8.61-21.51,9.42-6.88,1.92-6.49.64c-.73-2.06-12.23-5.5-12.76-9.48l1.54-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M148.28,101.24c0,5.83-.1,12.23-3.43,15.93a26.56,26.56,0,0,1-20.28,9.35c-8.75,0-15.68-4.48-20.51-9.86-3.21-3.58-3.19-9.8-3.19-15.42,0-17,10.61-30.75,23.7-30.75S148.28,84.25,148.28,101.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M106.08,96.38c0-4.53.08-9.49,2.68-12.36a20.72,20.72,0,0,1,15.79-7.26c6.82,0,12.22,3.48,16,7.65C143,87.19,143,92,143,96.38c0,13.18-8.27,23.86-18.47,23.86S106.08,109.56,106.08,96.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 111.29,
    y: 122.88,
    width: 4.12,
    height: 6.11,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 115.41,
    y: 122.88,
    width: 4.12,
    height: 6.31,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 119.53,
    y: 122.88,
    width: 4.12,
    height: 5.99,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 126.52,
    y: 122.88,
    width: 4.12,
    height: 6.11,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 130.64,
    y: 122.88,
    width: 4.12,
    height: 6.31,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 134.75,
    y: 122.88,
    width: 4.12,
    height: 5.99,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 111.29,
    y: 126.39,
    width: 12.36,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 126.52,
    y: 126.39,
    width: 12.36,
    height: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M150.91,67.7c0,.29,0,.59,0,.88,0-.49,0-1,0-1.5C150.91,67.29,150.91,67.49,150.91,67.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M150.9,67.08c0,.51,0,1,0,1.5,0,.11,0,.22,0,.33a26.13,26.13,0,0,1-52.18.58s0,0,0-.06c0-.57-.06-1.15-.06-1.73a138.33,138.33,0,0,1,.44-14.44c.49-3.67,1-4.62,7.05-2.33,4.74-4,11.35-6.24,18.65-6.24s13.9,2.19,18.64,6.23c6-2.28,6.55-1.33,7,2.34A133.72,133.72,0,0,1,150.9,67.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M98.69,69.43a5.48,5.48,0,0,1-.06-.85V67.7C98.63,68.28,98.65,68.86,98.69,69.43Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 111.84,
    cy: 70.75,
    rx: 11.85,
    ry: 12.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 137.7,
    cy: 70.75,
    rx: 11.85,
    ry: 12.14
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4df87",
    points: "120.48 81.35 129.06 81.35 124.77 88.37 120.48 81.35"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 112.89,
    cy: 71.75,
    rx: 9.98,
    ry: 10.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 136.65,
    cy: 71.75,
    rx: 9.98,
    ry: 10.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4f4f4f",
    cx: 115.65,
    cy: 73.69,
    rx: 3.33,
    ry: 4.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4f4f4f",
    cx: 133.88,
    cy: 73.69,
    rx: 3.33,
    ry: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4df87",
    d: "M106.1,51c4.11,1.5,26.9-2.17,28.67-3.67S108,0,108,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 110.56,
    cy: 38.75,
    rx: 1.76,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 125.53,
    cy: 36.64,
    rx: 1.76,
    ry: 2.33,
    transform: "translate(-5 44.52) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 118.98,
    cy: 23.23,
    rx: 1.76,
    ry: 2.33,
    transform: "translate(-0.86 41.52) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 112.33,
    cy: 15.52,
    rx: 1.65,
    ry: 2.18,
    transform: "translate(1.35 38.82) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 109.64,
    cy: 25.56,
    rx: 1.76,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 117.36,
    cy: 31.24,
    rx: 2.13,
    ry: 2.63,
    transform: "translate(-4.08 29.84) rotate(-14.24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M106.1,51c4.11,1.5,26.9-2.17,28.67-3.67.41-.35.88-4-1.25-8-2.43-4.6-4.43,3.81-7.68,5C123.41,45.21,118,39,116,41a46.53,46.53,0,0,0-5.23,6l-4.83-3.47a.67.67,0,0,0-1,.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4df87",
    d: "M179,119.16c4.11,1.5,26.9-2.17,28.67-3.67S181,68.16,181,68.16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 183.49,
    cy: 106.91,
    rx: 1.76,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 198.46,
    cy: 104.8,
    rx: 1.76,
    ry: 2.33,
    transform: "translate(-23.73 73.13) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 191.91,
    cy: 91.39,
    rx: 1.76,
    ry: 2.33,
    transform: "translate(-19.58 70.14) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 185.25,
    cy: 83.68,
    rx: 1.65,
    ry: 2.18,
    transform: "translate(-17.37 67.44) rotate(-19.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 182.57,
    cy: 93.72,
    rx: 1.76,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9574a8",
    cx: 190.29,
    cy: 99.4,
    rx: 2.13,
    ry: 2.63,
    transform: "translate(-18.61 49.88) rotate(-14.24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M179,119.16c4.11,1.5,26.9-2.17,28.67-3.67.41-.35.88-4-1.25-8-2.43-4.6-4.43,3.81-7.68,5-2.43.89-7.82-5.31-9.84-3.36a46.53,46.53,0,0,0-5.23,6l-4.84-3.47a.66.66,0,0,0-1,.66Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/Happy.9357040f1677f903e57743aa3c145ccc.svg";
export { ForwardRef as ReactComponent };